import React from 'react'
import classNames from 'classnames'
import { Icon } from '@/ui/atoms/Icon'
import { MegaMenuItem } from './types'
import Link from 'next/link'
import { Label } from '@/ui/atoms/Label'
import { useTranslations } from 'next-intl'

type MenuItemProps = {
  link: MegaMenuItem['categories'][0]['links'][0]
  isHovered: boolean
  onClick?: () => void
  onHover?: () => void
}

export const MenuItem: React.FC<MenuItemProps> = ({ link, isHovered, onClick, onHover }) => {
  const t = useTranslations('public')
  return link.isComingSoon ? (
    <div className="relative">
      <div
        className={classNames(
          'transition-all w-full rounded-md px-4 py-2 flex gap-3 flex-row items-center justify-start text-label-S-regular text-text-faded',
        )}
      >
        <span className={'opacity-75'}>{link.label}</span>
        <Label title={t('coming-soon')} variant={'subtle-blue'} size={'small'} />
      </div>
    </div>
  ) : (
    <div className="relative" onMouseEnter={onHover}>
      <Link
        className={classNames(
          'transition-all w-full rounded-md px-4 py-3 flex gap-2 flex-row items-center justify-between text-label-S-regular text-text-faded hover:underline',
          { 'bg-bg-brand-blue !text-label-S-semibold !text-text-base': isHovered },
        )}
        href={link.href}
        onClick={onClick}
      >
        <span>{link.label}</span>
        <Icon
          parentClass={'size-4'}
          name={'arrow-right-line'}
          className={`${isHovered ? 'visible' : 'invisible'}`}
        />
      </Link>
    </div>
  )
}
